import dotAccess from 'dot-access';

export const filterValue =  ({ resource, name, formatter }) => {
  const value = dotAccess.get(resource, name);
  if (value && formatter) {
    return formatter(value);
  }

  return value;
};

export const filterValueWithDefault = (defaultValue, { resource, name, formatter }) => {
  const value = filterValue({ resource, name, formatter });

  return value ? value : defaultValue;
};



// WEBPACK FOOTER //
// ./src/main/components/output/filterValue.js